import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.details.cryptoExchange';
const LABELS = makeLabels(
  {
    TITLE: ['title', 'Crypto Exchange'],
    LIQUIDITY_PROVIDER: ['liquidityProvider', 'Liquidity Provider'],
    TX_ID: ['txId', 'Provider Txn ID'],
    CRYPTO_PRICE: ['cryptoPrice', 'Crypto Price'],
    CRYPTO_PRICE_VALUE: ['cryptoPriceValue', '{{cryptoPrice}}<spacer/>≈<spacer/>{{fiatValue}}'],
  },
  NAMESPACE,
);

export default LABELS;
